import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { registerLicense } from '@syncfusion/ej2-base';
import { Auth0Provider } from '@auth0/auth0-react';

registerLicense("Ngo9BigBOggjHTQxAR8/V1NCaF1cXGdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXZfdnVQQmNeVEF1XEQ=")

const elem = <div>
  <link href="https://cdn.syncfusion.com/ej2/24.1.41/material3.css" rel="stylesheet" />
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN" crossOrigin="anonymous" />
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
  <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience:"ImavenAPI",
          scope:"openid profile email"
        }}
        
        >
      <App />
    </Auth0Provider>
  </Router>
</div>

const container = document.getElementById('root');
const root = createRoot(container);
root.render(elem);
